// posApk.js — where the POS app (Sunmi V3) APK is downloaded from.
// The POS web app hosts the latest build under a stable name; never a versioned
// file name, so the QR on the devices page keeps working after every release.
//
//   https://api.madamefin.com       → https://pos.madamefin.com/mdf-latest.apk
//   https://api-stg.madamefin.com   → https://pos-stg.madamefin.com/mdf-latest.apk
//   anything else (localhost, test) → the staging URL
export const POS_APK_FILE = "mdf-latest.apk";
export const POS_APK_URL_PROD = "https://pos.madamefin.com/" + POS_APK_FILE;
export const POS_APK_URL_STG = "https://pos-stg.madamefin.com/" + POS_APK_FILE;

export function posApkUrl(apiBase) {
	let host = "";
	try {
		host = new URL(String(apiBase || "").trim()).host.toLowerCase();
	} catch (e) {
		host = "";
	}
	return host === "api.madamefin.com" ? POS_APK_URL_PROD : POS_APK_URL_STG;
}

export default { posApkUrl, POS_APK_FILE, POS_APK_URL_PROD, POS_APK_URL_STG };
